/** @prettier */
//-------------------------------------
//		機器操作画面 上部バー
//-------------------------------------

import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

//API import
import {
  getCompositionsSitesBySiteID,
  getCompositionsGroupsByGroupID,
  getStatesSitesSl,
} from '../API/API_Collection';
//interface import
import * as apiIF from '../Type/api';
//Style import
import '../css/common/common.css';

import {iconWhite} from '../define';

/**
 * 機器操作画面 上部バー
 * @param props props
 * - setOpeDisplay 空調機指令ダイアログ開閉
 * - opeTarget 指令対象
 * - opeTargetID　指令対象ID
 * - opeSiteID　サイトID
 * @returns JSX
 */
const OperationHeader = (props: {
  opeTarget: apiIF.reqParameters.postCommandsSitesQuery['mode'];
  opeTargetID: string;
  opeSiteID: string;
  operationCloseClick: () => void;
}) => {
  const [targetName, setTargetName] = useState('');

  const trans = useTranslation().t; //翻訳関数

  useEffect(() => {
    switch (props.opeTarget) {
      case 'site':
        getCompositionsSitesBySiteID(props.opeSiteID).then(response => {
          setTargetName(response['site-name']);
        });
        break;
      case 'floors':
        setTargetName(
          `${trans(
            `ButtonAppBar.floor.floor${props.opeTargetID.replace('-', 'B')}`
          )}`
        );
        break;
      case 'groups':
        getCompositionsGroupsByGroupID(props.opeSiteID, props.opeTargetID).then(
          response => {
            setTargetName(response['group-name']);
          }
        );
        break;
      case 'sl':
        getStatesSitesSl(props.opeSiteID).then(response => {
          for (const states of response['sl-states'][0]['states']) {
            if (
              states['unit-id'] === props.opeTargetID &&
              states['unit-name'] !== undefined
            ) {
              setTargetName(states['unit-name']);
              break;
            }
          }
        });
        break;
    }
  }, [props.opeTargetID, props.opeTarget, props.opeSiteID]);

  const close = () => {
    props.operationCloseClick();
  };

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs="auto">
        <IconButton aria-label="Operation close" onClick={close}>
          <img
            src={iconWhite.CLOSE.src}
            alt={`${trans(
              `ButtonAppBar.image.alternativeText.${iconWhite.CLOSE.alt}`
            )}`}
            title={`${trans(
              `ButtonAppBar.image.title.${iconWhite.CLOSE.title}`
            )}`}
            className="operation__card__header__icon"
          />
        </IconButton>
      </Grid>
      <Grid item xs className="operation__card__header__title">
        {targetName}
      </Grid>
    </Grid>
  );
};

export default OperationHeader;
